
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  data: function () {
    var self = this;
    var app = self.$app;
    var endpoints = app.data.api.endpoints;
    var endpoint = endpoints[0];
    return {
      endpoints: endpoints,
      endpoint: endpoint,
      allowInfinite: true,
      hasMoreItems: true,
      lastPage: 1,
      stories: [],
      indexTopic: 0
    };
  },
  methods: {
    fetchStories() {
      var self = this;
      var app = self.$app;
      var url = self.endpoint.url.substring(0, self.endpoint.url.lastIndexOf('/') + 1);
      app.request.json(url + self.lastPage + '.json', items => {
        var stories = self.stories.concat(items);
        self.$setState({
          stories: stories,
          lastPage: self.lastPage + 1,
          allowInfinite: true
        });
      });
    },
    loadMore() {
      var self = this;
      var $ = self.$$;
      if (!self.allowInfinite)
        return;
      self.allowInfinite = false;
      if (self.lastPage > self.endpoint.maxPages) {
        self.$setState({ hasMoreItems: false });
        return;
      }
      self.fetchStories();
    },
    selectTopic(index) {
      var self = this;
      self.$setState({
        endpoint: self.endpoints[index],
        stories: [],
        lastPage: 1,
        allowInfinite: true,
        hasMoreItems: self.endpoints[index].maxPages > 1 ? true : false,
        indexTopic: index
      });
      self.fetchStories();
    }
  },
  on: {
    pageInit() {
      var self = this;
      self.fetchStories();
    }
  },
  id: 'a287cc42db',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page" data-name="stories">\n      <div class="navbar">\n        <div class="navbar-inner sliding">\n          <div class="title">HackerNews7</div>\n        </div>\n      </div>\n      <div class="toolbar tabbar tabbar-scrollable toolbar-top">\n        <div class="toolbar-inner">\n          ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.endpoints, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.maxPages, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n          <a href="#tab-';
              r += c(data_3 && data_3.index, ctx_3);
              r += '" class="tab-link';
              r += Template7Helpers.if.call(ctx_3, data_3 && data_3.first, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += ' tab-link-active';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '" @click="selectTopic(';
              r += c(data_3 && data_3.index, ctx_3);
              r += ')">';
              r += c(ctx_3.topic, ctx_3);
              r += '</a>\n          ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n        </div>\n      </div>\n      <div class="tabs">\n        ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.endpoints, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.maxPages, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n        <div id="tab-';
              r += c(data_3 && data_3.index, ctx_3);
              r += '" data-infinite-distance="50" class="page-content infinite-scroll-content tab';
              r += Template7Helpers.if.call(ctx_3, data_3 && data_3.first, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += ' tab-active';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '"\n          @infinite="loadMore">\n          <div class="list">\n            <ul>\n              ';
              r += Template7Helpers.each.call(ctx_3, root.stories, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n              <li>\n                <a data-reload-detail="true" href="/story/';
                  r += c(ctx_4.id, ctx_4);
                  r += '/" class="item-link">\n                  <div class="item-content">\n                    <div class="item-inner">\n                      <div class="item-title">\n                        ';
                  r += c(ctx_4.title, ctx_4);
                  r += ' (';
                  r += c(ctx_4.domain, ctx_4);
                  r += ')\n                        <div class="item-footer">';
                  r += c(ctx_4.points, ctx_4);
                  r += ' ';
                  r += Template7Helpers.pluralize.call(ctx_4, ctx_4.points, {
                    hash: {
                      'single': 'point',
                      'multiple': 'points'
                    },
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += ' ';
                  r += Template7Helpers.if.call(ctx_4, ctx_4.user, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += ' by ';
                      r += c(ctx_5.user, ctx_5);
                      r += ' ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += c(ctx_4.time_ago, ctx_4);
                  r += '</div>\n                      </div>\n                      ';
                  r += Template7Helpers.if.call(ctx_4, ctx_4.comments_count, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                      <div class="item-after">\n                        <span class="badge">';
                      r += c(ctx_5.comments_count, ctx_5);
                      r += '</span>\n                      </div>';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                    </div>\n                  </div>\n                </a>\n              </li>\n              ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n            </ul>\n          </div>\n          ';
              r += Template7Helpers.if.call(ctx_3, root.hasMoreItems, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n          <div class="preloader infinite-scroll-preloader"></div>\n          ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n        </div>\n        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n    </div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};
    